module.exports = __webpack_public_path__ + "img/ic-mode-fullscreen.389b64a4.svg";